import React, { useState } from "react";
import ActionsMenu from "../../shared/components/ActionsMenu";
import EditIcon from "../../shared/Icons/EditIcon";
import ArchiveIcon from "../../shared/Icons/ArchiveIcon";
import XCloseIcon from "../../shared/Icons/XCloseIcon";
import GlobeIcon from "../../shared/Icons/GlobeIcon";
import EyeOffIcon from "../../shared/Icons/EyeOffIcon";

const deleteModalContentStyle = {
  textAlign: 'left',
  border: 'none',
  borderRadius: '12px',
  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
  maxWidth: '420px',
  width: '90%',
  padding: '0'
};

const MembershipActionsMenu = ({
  membershipProduct,
  team,
  onDelete,
  onStatusChange,
  openUpwards = false
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleEdit = () => {
    window.location.href = `/teams/${team.id}/membership_products/${membershipProduct.id}/edit`;
  };

  const handleArchiveClick = (e) => {
    e.preventDefault();
    setConfirmOpen(true);
  };

  const handleCloseConfirm = () => {
    setConfirmOpen(false);
  };

  const handlePublish = (e) => {
    e.preventDefault();
    onStatusChange(membershipProduct, "active");
  };

  const handleUnpublish = (e) => {
    e.preventDefault();
    onStatusChange(membershipProduct, "draft");
  };

  const isDraft = membershipProduct.status === 'draft';

  const actions = [
    { label: "Edit Membership", icon: <EditIcon fill="currentColor" width="16" height="16" />, onClick: handleEdit },
    isDraft
      ? { label: "Publish Membership", icon: <GlobeIcon fill="currentColor" width="16" height="16" />, onClick: handlePublish }
      : { label: "Unpublish Membership", icon: <EyeOffIcon fill="currentColor" width="16" height="16" />, onClick: handleUnpublish },
    { label: "Archive Membership", icon: <ArchiveIcon fill="currentColor" width="16" height="16" />, onClick: handleArchiveClick, danger: true },
  ];

  return (
    <>
      <ActionsMenu
        actions={actions}
        openUpwards={openUpwards}
        buttonClassNames={["team-actions-btn-square"]}
      />

      {confirmOpen && (
        <div className="team-modal-overlay">
          <div className="team-modal" style={deleteModalContentStyle}>
            <div className="team-modal-header">
              <h3 className="team-modal-title">Archive membership?</h3>
              <button
                type="button"
                aria-label="Close"
                className="team-modal-close"
                onClick={handleCloseConfirm}
              >
                <XCloseIcon fill="currentColor" width="16" height="16" />
              </button>
            </div>
            <div className="team-modal-body">
              <p style={{ marginBottom: '8px' }}>
                Archive <strong>{membershipProduct.name}</strong>?
              </p>
              <p>Archived memberships will not be accessible.</p>
            </div>
            <div className="team-modal-footer">
              <button
                type="button"
                className="team-btn-secondary"
                onClick={handleCloseConfirm}
              >
                Cancel
              </button>
              <button
                type="button"
                className="team-btn-danger"
                onClick={(e) => {
                  e.preventDefault();
                  handleCloseConfirm();
                  onDelete(membershipProduct);
                }}
              >
                Archive
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MembershipActionsMenu;
